import React from 'react';

type LegendLabel = {
  text: string;
  color: string;
};

type ChartLegendProps = {
  labels: LegendLabel[];
};

function ChartLegend({ labels }: ChartLegendProps) {
  const getLegendIcon = (label: LegendLabel) => {
    if (label.text.includes('действия')) {
      return (
        <div className="flex items-center">
          <div 
            className="w-6 h-0.5 rounded-full"
            style={{ backgroundColor: label.color }}
          />
          <div 
            className="w-2 h-2 rounded-full -ml-1"
            style={{ backgroundColor: label.color }}
          />
        </div>
      );
    } else {
      return (
        <div 
          className="w-4 h-4 rounded-sm"
          style={{ backgroundColor: label.color }}
        />
      );
    }
  };

  return (
    <div className="flex justify-center flex-wrap gap-6 mt-2">
      {labels.map((label, index) => (
        <div key={index} className="flex items-center gap-2">
          {getLegendIcon(label)}
          <span className="text-sm text-gray-600 font-normal">
            {label.text}
          </span>
        </div>
      ))}
    </div>
  );
}

export default ChartLegend;